import { AdditionalInformationPagarMe } from "./additional-information-pagar-me";

export class PixPagarMe {
	expires_in: string;
	additional_information: AdditionalInformationPagarMe[] = [];

	constructor() {
	
	}
}